import axios from 'axios';
import React, { CSSProperties, FunctionComponent, useEffect, useState } from 'react';
import {
    Link,
    Navigate
} from "react-router-dom";
import api from './api';
import { BsUserRegistration, BsUserLoggedIn, WithStringId, Address } from './types'


const LoginForm: FunctionComponent<{ onSubmit: (username: string, password: string) => void, pending: boolean }> = ({ onSubmit, pending }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    return <form onSubmit={(e) => {
        e.preventDefault();
        onSubmit(email, password)
    }
    }>
        <div className="form-group mb-2">
            <label htmlFor="email">Email</label>
            <input type="text" className="form-control" id="email" placeholder="Enter email" onChange={e => setEmail(e.currentTarget.value)} value={email} />
        </div>
        <div className="form-group mb-2">
            <label htmlFor="password">Password</label>
            <input type="password" className="form-control" id="password" placeholder="Password" onChange={e => setPassword(e.currentTarget.value)} value={password} />
        </div>
        <div className='d-flex flex-row-reverse'>
            <button type="submit" className="btn btn-primary" disabled={pending}>Login</button>
        </div>
    </form>
}

const RegisterForm: FunctionComponent<{ onSubmit: (user: BsUserRegistration, agree: boolean) => void, pending: boolean }> = ({ onSubmit, pending }) => {
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [agree, setAgree] = useState(false);
    const [password, setPassword] = useState('');
    const [birthday, setBirthday] = useState(0);

    return <form onSubmit={(e) => {
        e.preventDefault();
        onSubmit({ email, firstName, lastName, password, username: '', birthday, readyToTrade: false }, agree);
    }
    }>
        <div className="form-group mb-2">
            <label htmlFor="name">Name</label>
            <div className='row'>
                <div className='col'>
                    <input type="text" className="form-control" placeholder="First name" onChange={e => setFirstName(e.currentTarget.value)} value={firstName} />
                </div>
                <div className='col'>
                    <input type="text" className="form-control" placeholder="Last name" onChange={e => setLastName(e.currentTarget.value)} value={lastName} />
                </div>
            </div>
        </div>
        <div className="form-group mb-2">
            <label htmlFor="email">Email address</label>
            <input type="email" className="form-control" placeholder="Enter email" onChange={e => setEmail(e.currentTarget.value)} value={email} />
            <small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small>
        </div>

        <div className="form-group mb-2">
            <label htmlFor="password">Password</label>
            <input type="password" className="form-control" id="password" placeholder="Password" onChange={e => setPassword(e.currentTarget.value)} value={password} />
        </div>
        <div className='form-group mb-2'>
            <label htmlFor="birthday">Birthday</label>
            <input type='date' className='form-control' onChange={e => setBirthday(e.currentTarget.valueAsNumber)} />
        </div>
        <div className="form-check mb-3 mt-3">
            <input type="checkbox" className="form-check-input" id="toscheck" onChange={(e) => setAgree(e.currentTarget.checked)} checked={agree} />
            <label className="form-check-label" htmlFor="toscheck">I've read and agree to BackyardSwap's <a href='/terms' target='_blank'>Terms of Service</a></label>
        </div>
        <div className='d-flex flex-row-reverse'>
            <button type="submit" className="btn btn-primary" disabled={pending}>Register</button>
        </div>
    </form>
}

export const RegisterRoute: FunctionComponent = () => {
    const [alert, setAlert] = useState('');
    const [alertSuccess, setAlertSuccess] = useState(false);
    const [pending, setPending] = useState(false);

    const errorAlert = (alertText: string) => {
        setAlert(alertText);
        setAlertSuccess(false);
    }
    const successAlert = (alertText: string) => {
        setAlert(alertText);
        setAlertSuccess(true);
    }
    return <>
        {alert ? <div className={'alert ' + (alertSuccess ? 'alert-success' : 'alert-danger')}>
            {alert}
        </div>
            : null
        }
        <div className='row'>
            <div className='col-md-6 offset-md-3'>
                <RegisterForm pending={pending} onSubmit={({ email, password, firstName, lastName, username, birthday }, agree) => {
                    if (!firstName) {
                        return errorAlert('Enter a valid first name');
                    } else if (!lastName) {
                        return errorAlert('Enter a valid last name');
                    } else if (!password) {
                        return errorAlert('Enter a valid password. Password must be at least 6 characters');;
                    } else if (!agree) {
                        return errorAlert('You must agree to the terms and conditions below')
                    } else if (!birthday) {
                        return errorAlert('You must enter a valid birthdate')
                    }
                    setPending(true);
                    api.register({ email, password, firstName, lastName, username, birthday: birthday + (new Date().getTimezoneOffset() * 60 * 1000), readyToTrade: false })
                        .then(() => {
                            // setPending(false);
                            successAlert("You have successfully registered, go to the login page to log in")
                        })
                        .catch((err) => {
                            setPending(false);
                            errorAlert(err);
                        })
                }} />
            </div>
        </div>

    </>
}



export const LoginRoute: FunctionComponent<{ onUser: (user: WithStringId<BsUserLoggedIn>) => void }> = ({ onUser }) => {
    const [alert, setAlert] = useState('');
    const [alertSuccess, setAlertSuccess] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [pending, setPending] = useState(false);
    const errorAlert = (alertText: string) => {
        setAlert(alertText);
        setAlertSuccess(false);
    }
    const successAlert = (alertText: string) => {
        setAlert(alertText);
        setAlertSuccess(true);
    }
    return <>
        {alert ? <div className={'alert ' + (alertSuccess ? 'alert-success' : 'alert-danger')}>
            {alert}
        </div>
            : null
        }
        <div className='row'>
            <div className='col-md-6 offset-md-3'>
                <LoginForm pending={pending} onSubmit={(email, password) => {
                    setPending(true);

                    api.login(email, password, true)
                        .then(user => {
                            onUser(user)
                            console.log('passed along user')
                            setRedirect(true);
                        })
                        .catch(err => {
                            errorAlert(err);
                            setPending(false);
                        })
                }} />
            </div>
        </div>
        {redirect ? <Navigate replace to='/' /> : null}
    </>
}
const DateEditor: FunctionComponent<{ value?: number; onChange: (value?: number) => void, className?: string }> = ({ value, onChange, className }) => {
    const getDateFormatted = () => {
        if (!value)
            return ''
        const date = new Date(value);

        return [date.getFullYear(), date.getMonth() + 1, date.getDate()].map(part => part < 10 ? '0' + part : part).join('-');
    }

    const getDateNumber = (nextValue?: string) => {
        if (!nextValue) return;
        const [year, month, day] = nextValue.split('-').map(part => parseInt(part));
        return new Date(year, month - 1, day).getTime();
    }
    return <input
        type='date'
        value={getDateFormatted()}
        className={'form-control ' + (className ?? '')}
        onChange={e => onChange(getDateNumber(e.currentTarget.value))}
    />
}

export const AccountRoute: FunctionComponent<{ user: BsUserLoggedIn, refreshUser: () => void }> = ({ user, refreshUser }) => {
    const [showAccountInfo, setShowAccountInfo] = useState(true);
    const [showPaymentAndShipping, setShowPaymentAndShipping] = useState(false);


    const switchAccountInfo = () => {
        setShowAccountInfo(true);
        setShowPaymentAndShipping(false);
    }
    const switchPaymentAndShipping = () => {
        setShowAccountInfo(false);
        setShowPaymentAndShipping(true);

    }
    return <div className='row'>
        <div className='col-md-2'>
            <div className='list-group'>
                <div className={'list-group-item p-3 ' + (showAccountInfo ? 'active' : '')} onClick={switchAccountInfo}>
                    Account Information
                </div>
                <div className={'list-group-item p-3 ' + (showPaymentAndShipping ? 'active' : '')} onClick={switchPaymentAndShipping}>
                    Billing/Shipping
                </div>
            </div>
        </div>
        <div className='col-md-10'>
            {showAccountInfo && <AccountInfo user={user} refreshUser={refreshUser} />}
            {showPaymentAndShipping && <AddressForm user={user}></AddressForm>}
        </div>
    </div>
}
const AccountInfo: FunctionComponent<{ user: BsUserLoggedIn, refreshUser: () => void }> = ({ user, refreshUser }) => {
    const [submittable, setSubmittable] = useState(false);
    const [firstName, setFirstName] = useState(user.firstName);
    const [lastName, setLastName] = useState(user.lastName);
    const [birthday, setBirthday] = useState(user.birthday || 0 as number | undefined);

    useEffect(() => {
        setSubmittable(checkSubmittable());
    }, [user, firstName, lastName, birthday])
    const onSubmit = () => {
        if (firstName && lastName && birthday) {
            api.updateAccount(firstName, lastName, birthday)
                .then(() => {
                    refreshUser();
                })
                .catch(err => {
                    alert(err);
                })
        }
    }
    const checkSubmittable = () => {
        if (!firstName || !lastName || !birthday)
            return false;
        if (firstName !== user.firstName || lastName !== user.lastName || birthday !== user.birthday)
            return true;
        return false;

    }
    return <div>
        <div className='d-flex justify-content-center'>
            <div><img src='/profile.jpg' height={256} width={256}></img></div>
        </div>
        <div className='row'>
            <div className='col-md-6 offset-md-3'>
                <table width='100%'>
                    <tbody>
                        <tr>
                            <td><strong>Email</strong></td>
                            <td><input type='text' value={user.email} disabled className='form-control' /></td>
                        </tr>
                        <tr>
                            <td><strong>Username</strong></td>
                            <td><input type='text' value={user.username} disabled className='form-control' /></td>
                        </tr>
                        <tr>
                            <td>
                                <strong>Name</strong>
                            </td>
                            <td className='d-flex justify-content-between gap-2'>
                                <input type='text' value={firstName} className='form-control' onChange={e => { setFirstName(e.currentTarget.value) }} />
                                <input type='text' value={lastName} className='form-control' onChange={e => { setLastName(e.currentTarget.value) }} />
                            </td>
                        </tr>

                        <tr>
                            <td><strong>Birthday</strong></td>
                            <td><DateEditor value={birthday} onChange={value => setBirthday(value)} /></td>
                        </tr>
                    </tbody>
                </table>
                <div className='mt-2'>
                    <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary' disabled={!submittable} onClick={onSubmit}>Submit</button>
                    </div>
                </div>
            </div>

        </div>
    </div>
}
interface ShippingInterface {
    orderId: string,
    selectedAddress: Address | undefined,
    addresses: Array<Address>
}

const AddressEditor: FunctionComponent<{
}> = ({ }) => {
    const [addressEditorOpen, setAddressEditorOpen] = useState(false);
    const [addressEditorIndex, setAddressEditorIndex] = useState(-1);
    const [submitting, setSubmitting] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [addressLine1, setAddressLine1] = useState('');
    const [addressLine2, setAddressLine2] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('Texas');
    const [postalCode, setPostalCode] = useState('');
    const [country, setCountry] = useState('United States');

    const [addresses, setAddresses] = useState([] as Array<Address>);

    const refreshAddresses = () => {
        api.getAddresses()
            .then(addresses => setAddresses(addresses))
            .catch(err => {
                alert(err);
            })
    }

    useEffect(() => {
        refreshAddresses();
    }, [])

    const saveAddress = () => {
        setSubmitting(true);

        const address: Address = {
            firstName,
            lastName,
            addressLine1,
            addressLine2,
            city,
            state,
            postalCode,
            country
        }
        const nextAddresses = addressEditorIndex === -1 ? [...addresses, address] : addresses.slice();
        if (addressEditorIndex !== -1) nextAddresses.splice(addressEditorIndex, 1, address)
        api.updateAddresses(nextAddresses)
            .then(() => {
                setAddressEditorOpen(false);
                setAddressEditorIndex(-1);
                refreshAddresses();
            })

    }


    const close = () => setAddressEditorOpen(false);
    const addressFormCompleted = () => (firstName && lastName && addressLine1 && city && state && postalCode && country) ? true : false;

    const getFooter = () => {
        if (addressEditorOpen) {
            return <>
                <button className='btn btn-secondary' onClick={() => setAddressEditorOpen(false)}>Cancel</button>
                <button type="submit" className="btn btn-primary" disabled={!addressFormCompleted()} onClick={saveAddress}>Submit</button>
            </>
        } else {
            return <><button className='btn btn-secondary' onClick={() => close()}>Close</button></>
        }
    }

    const ActualAddressEditor = () => {
        if (addressEditorOpen)
            return <form onSubmit={saveAddress}>
                <div className="row mb-1">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="firstName" className="form-label">
                                First Name
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="firstName"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="lastName" className="form-label">
                                Last Name
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="lastName"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                <div className="row mb-1">
                    <div className="col-sm-8">
                        <div className="form-group">
                            <label htmlFor="addressLine1" className="form-label">
                                Address
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="addressLine1"
                                value={addressLine1}
                                onChange={(e) => setAddressLine1(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="form-group">
                            <label htmlFor="addressLine2" className="form-label">
                                Address Line 2 (optional)
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="addressLine2"
                                value={addressLine2}
                                onChange={(e) => setAddressLine2(e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                <div className="row mb-1">
                    <div className="col-sm-4">
                        <div className="form-group">
                            <label htmlFor="city" className="form-label">
                                City
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="city"
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col-sm-5">
                        <div className="form-group">
                            <label htmlFor="state" className="form-label">
                                State
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="state"
                                value={state}
                                onChange={(e) => setState(e.target.value)}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="col-sm-3">
                        <div className="form-group">
                            <label htmlFor="postalCode" className="form-label">
                                Postal Code
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="postalCode"
                                value={postalCode}
                                onChange={(e) => setPostalCode(e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                <div className="row mb-1">
                    <div className="col-sm-12">
                        <div className="form-group">
                            <label htmlFor="country" className="form-label">
                                Country
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="country"
                                value={country}
                                onChange={(e) => setCountry(e.target.value)}
                                disabled
                            />
                        </div>
                    </div>
                </div>
            </form>
    }
    const openAddressEditor = (index: number) => {
        setAddressEditorOpen(true);
        setAddressEditorIndex(index);

        if (index === -1) {
            setFirstName('');
            setLastName('');
            setAddressLine1('');
            setAddressLine2('');
            setCity('')
            setState('Texas');
            setPostalCode('');
            setCountry('United States');
        } else {
            setFirstName(addresses[index].firstName);
            setLastName(addresses[index].lastName);
            setAddressLine1(addresses[index].addressLine1);
            setAddressLine2(addresses[index].addressLine2 || '');
            setCity(addresses[index].city)
            setState(addresses[index].state);
            setPostalCode(addresses[index].postalCode);
            setCountry(addresses[index].country);
        }
    }
    return <div>
        <ul className="list-group">
            {addresses.map((address, i) => <li className='list-group-item cursor-pointer' onClick={() => openAddressEditor(i)}>
                <div>{address.firstName} {address.lastName}</div>
                <div>{address.addressLine1}, {address.addressLine2 && address.addressLine2 + ', '}
                    {address.city}, {address.state}, {address.postalCode}</div>
                <div>{address.country}</div>
            </li>
            )}
            <li className="list-group-item" onClick={() => openAddressEditor(-1)}>
                Add new address
            </li>
        </ul>
        <Modal isOpen={addressEditorOpen} title='Shipping/Pickup Address' toggleModal={() => close()} footer={getFooter()}>
            {addressEditorOpen && ActualAddressEditor()}
        </Modal>
    </div>
}


const Modal: FunctionComponent<{ isOpen: boolean, toggleModal: () => void, title: string, footer?: React.ReactNode }> = ({ isOpen, toggleModal, title, children, footer }) => {
    const backdropStyle: CSSProperties = {
        zIndex: isOpen ? 1000 : -1, // Lower z-index value for the backdrop
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Dark semi-transparent backdrop color
        display: isOpen ? 'block' : 'none',
    };

    return <div>
        <div style={backdropStyle} onClick={toggleModal} />
        <div className={`modal modal-lg ${isOpen ? 'show d-block' : ''}`}>
            <div className="modal-dialog  modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                        <button type="button" className="btn-close" onClick={toggleModal} />
                    </div>
                    <div className="modal-body">{children}</div>
                    <div className="modal-footer">
                        {footer || <button type="button" className="btn btn-secondary" onClick={toggleModal}>
                            Close
                        </button>}
                    </div>
                </div>
            </div>
        </div>
    </div>;
};

const AddressForm: FunctionComponent<{ user: BsUserLoggedIn }> = ({ user }) => {
    return <div>
        <h3>Shipping</h3>
        <AddressEditor></AddressEditor>
        <h3 className='mt-2'>Payment</h3>

    </div>
}

export const LogoutRoute: FunctionComponent<{ onUser: (user: WithStringId<BsUserLoggedIn> | undefined) => void }> = ({ onUser }) => {
    const [redirect, setRedirect] = useState(false);

    useEffect(() => {
        axios.get('/api/logout')
            .finally(() => {
                onUser(undefined);
                setTimeout(() => setRedirect(true), 2000);
            });
    }, [])
    return <div>
        <div className={'alert alert-success'}>Successfully signed out. Redirecting you in 2 seconds...</div>
        {redirect ? <Navigate replace to='/' /> : null}
    </div>
}
